import { Component } from 'react';

import { tableColumns } from './keys';
import CheckData from '../../../components/CatchError';
import DataTable from '../../../components/Datatable';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class PositionModule2 extends Component {
    constructor() {
        super();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item.searchappearance?.toLowerCase().includes(search.toLowerCase()),
        );
    }

    render() {
        const { t } = this.props;
        const sortFns = {
            searchappearance: (array) =>
                array.sort((a, b) => a.searchappearance.localeCompare(b.searchappearance)),
            avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
            avgCTR: (array) =>
                array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
        };

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.props.data}
                    loading={this.props.loading}
                    loadMore={this.props.loadMore}
                >
                    <DataTable
                        nodes={this.props.data}
                        sortFns={sortFns}
                        COLUMNS={tableColumns(t)}
                        searchFunction={this.searchFunction}
                        fileName={t('search.search_appearance.header')}
                        header={t('search.search_appearance.header')}
                        defaultSortKey="clicks"
                        forceRun={this.props.forceRun}
                        uniqKey={'searchappearance'}
                        additionalStyles={{
                            Table: `
                                --data-table-library_grid-template-columns : minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                            BaseCell: `  font-family: 'Raleway';
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 19px;
                            padding: 16px 10px;
                            color: #0D182C;
                        
                        
                            &.underline {
                              text-decoration: underline;
                            }`,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default withTranslation()(PositionModule2);
